// extracted by mini-css-extract-plugin
export var dropdownContainer = "_py-0";
export var leftAlign = "_py-4";
export var listItem = "_py-2";
export var listItemWrapper = "_py-1";
export var operationText = "_py-3";